var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesignWork1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7222 65.6602L33.7167 71.6016H44.2833L44.2778 65.6602H33.7222Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7242 63.5273H44.2758L44.2458 30.3164H33.7542L33.7242 63.5273Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7519 28.1834H43.2481L39 22.1909L34.7519 28.1834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1672 10.1919C33.1462 10.1968 33.1256 10.2027 33.1048 10.2071H12.3398V12.3399H27.2848C23.8459 14.1014 20.8539 16.6237 18.5362 19.7151C16.2184 22.8065 14.6359 26.3856 13.909 30.1803L16.004 30.5808C16.8443 26.1958 18.9276 22.1448 22.0057 18.9107C25.0838 15.6766 29.0269 13.3957 33.3651 12.3399H33.668V10.2071H33.1707L33.1672 10.1919ZM63.9144 30.3378C63.209 26.5115 61.6335 22.8986 59.3097 19.7779C56.986 16.6573 53.9761 14.1124 50.5125 12.3399H65.6602V10.2071H44.6893C44.6683 10.2023 44.6477 10.1963 44.6268 10.1919L44.6232 10.2071H44.332V11.4716L44.1483 12.2697C44.21 12.2839 44.2702 12.3002 44.332 12.3154V12.3399H44.4289C48.7926 13.399 52.7564 15.6985 55.8419 18.9609C58.9274 22.2233 61.0026 26.3091 61.817 30.7249L63.9144 30.3378Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0312 31.5352H59.7188V38.8477H67.0312V31.5352Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1289 31.5352H10.8164V38.8477H18.1289V31.5352Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.897 14.8002C39.7314 14.8002 40.547 14.5528 41.2408 14.0892C41.9346 13.6257 42.4753 12.9668 42.7946 12.1959C43.1139 11.4251 43.1974 10.5768 43.0347 9.75847C42.8719 8.94012 42.4701 8.18842 41.8801 7.59842C41.2901 7.00843 40.5384 6.60664 39.72 6.44386C38.9017 6.28108 38.0535 6.36462 37.2826 6.68392C36.5117 7.00323 35.8529 7.54395 35.3893 8.23771C34.9257 8.93147 34.6783 9.74712 34.6783 10.5815C34.6796 11.7 35.1244 12.7723 35.9153 13.5632C36.7062 14.3541 37.7785 14.799 38.897 14.8002Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 8.37891H5.78906V13.8633H11.1211V8.37891Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2109 8.37891H66.8789V13.8633H72.2109V8.37891Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignWork1);
export default __webpack_public_path__ + "static/media/DesignWork1.909cf03ee8c97280bb87c91244c5385d.svg";
export { ForwardRef as ReactComponent };